import { Controller } from '@hotwired/stimulus'
import { Turbo } from '@hotwired/turbo-rails'

import { generateAndUploadDeviceKey, TokenType } from '../encryption/encryption'

import PasswordValidationController from './password_validation_controller'

/**
 * EncryptionController allow the creation and set of the encryption keys
 */
export default class EncryptionPasswordController extends Controller<HTMLFormElement> {
  static targets = ['passwordInput', 'form']

  static values = { redirectPath: String }

  async setPassword(event: Event) {
    event.stopPropagation()
    event.preventDefault()

    const validationController = this.application.getControllerForElementAndIdentifier(
      this.formTarget,
      'password-validation',
    ) as PasswordValidationController

    const isFormValid = await validationController.preventInvalidSubmission(undefined)

    if (!isFormValid) {
      return
    }

    const password = this.passwordInputTarget.value
    const success = await generateAndUploadDeviceKey(password, TokenType.Password)

    if (success) {
      Turbo.visit(this.redirectPathValue, { action: 'replace' })
    }
  }

  declare passwordInputTarget: HTMLInputElement
  declare formTarget: HTMLFormElement

  declare redirectPathValue: string
}
